<template>
	<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
		<FormItem prop="trackName">
			<FormItem prop="trackName">
				<Input style="width: 150px;" type="text" v-model="formInline.PhoneNo" :placeholder="this.$t('Individual.PhoneNo')">
				<span slot="prepend">{{ $t('Individual.PhoneNo') }}</span>
				</Input>
			</FormItem>
		</FormItem>
		<FormItem prop="trackName">
			<FormItem prop="trackName">
				<Input style="width: 150px;" type="text" v-model="formInline.MemberName" :placeholder="this.$t('Individual.MemberName')">
				<span slot="prepend">{{ $t('Individual.MemberName') }}</span>
				</Input>
			</FormItem>
		</FormItem>
		<FormItem prop="trackName">
			<FormItem prop="trackName">
				<Input style="width: 150px;" type="text" v-model="formInline.ChargeCardNo" :placeholder="this.$t('Individual.CardNo')">
				<span slot="prepend">{{ $t('Individual.CardNo') }}</span>
				</Input>
			</FormItem>
		</FormItem>
		<FormItem :label="this.$t('Individual.TransactionType')" :label-width="70" prop="trackName">
			<Select :placeholder="this.$t('Individual.TransactionType')" style="width: 120px;" v-model="formInline.TransactionType">
				<Option :value='0'>{{ this.$t('Common.All') }}</Option>
				<Option :value='1'>{{ this.$t('Individual.WalletRecharge') }}</Option>
				<Option :value='2'>{{ this.$t('Individual.WalletRefund') }}</Option>
				<Option :value='3'>{{ this.$t('Individual.WalletConsume') }}</Option>
				<!-- <Option :value='4'>赠送</Option> -->
				<Option :value='11'>{{ this.$t('Individual.ImmediateRecharge') }}</Option>
				<Option :value='12'>{{ this.$t('Individual.ImmediateConsume') }}</Option>
				<Option :value='13'>{{ this.$t('Individual.ImmediateRefund') }}</Option>
			</Select>
		</FormItem>
		<FormItem :label="$t('Common.Time')" :label-width='70'>
			<DatePicker style="width: 210px;" type="daterange" format="yyyy-MM-dd" placeholder="Select date"
				v-model="formInline.TimeRange" @on-change="handleChange"></DatePicker>
		</FormItem>
		
		<FormItem>
			<Button type="primary" @click="$emit('handleSubmit')" v-if="hasWidgets('search')">{{ $t('Common.Search') }}</Button>
		</FormItem>
		<FormItem>
			<Button type="primary" @click="$emit('exportFile')" v-if="hasWidgets('export')">{{ this.$t('ChargeRecord.ExportFile') }}</Button>
		</FormItem>
	</Form>
</template>

<script>
	import dateFormat from '../../../../../public/js/comm.js'
	export default {
		//props: ['param', 'url'],
		data() {
			return {
				formInline: {
					MemberId: '',
					MemberName: '',
					ChargeCardNo: '',
					TransactionType: 0,
					TimeBegin: dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24), 'yyyy-MM-dd'),
					TimeEnd: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					TimeRange: [new Date(new Date().getTime() - 1000 * 60 * 60 * 24), new Date()],
					Source: 1,
				}
			};
		},
		computed: {
			// pageParam: function() {
			// 	const _this = this;
			// 	const param = {
			// 		OperatorId: _this.formInline.OperatorId
			// 	}
			// 	return param
			// },
		},
		mounted() {
			// console.log(dateFormat);
			// this.formInline.TimeBegin = dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24), 'yyyy-MM-dd');
			// this.formInline.TimeEnd = dateFormat.formatDate(new Date(), 'yyyy-MM-dd');
			// // this.formInline.TimeRange = [new Date(new Date().getTime() - 1000 * 60 * 60 * 24), new Date()];
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleChange(date, type) {
				console.log("日期改变：", date, type);
				this.formInline.TimeBegin = date[0];
				this.formInline.TimeEnd = date[1];
			}
		},
	}
</script>

<style>
</style>
